import * as app from './modules/app'
import * as account from './modules/account'
import * as users from './modules/users'
import * as notifications from './modules/notifications'
import * as assistant from './modules/assistant'
import * as presence from './modules/presence'

const reducers = {
  ...app.reducers,
  ...account.reducers,
  ...users.reducers,
  ...notifications.reducers,
  ...assistant.reducers,
  ...presence.reducers,
}

export default reducers
